import { ElementType } from 'react'
import { AreaOfInterestSelection } from './AreaOfInterestSelection'
import pdfImage from '../../images/gallerium/onDemand/pdf-thumbnail.png'
import posterImage from '../../images/gallerium/onDemand/poster-thumbnail.png'
import videoImage from '../../images/gallerium/onDemand/video-thumbnail.png'
import oralThumbnail from '../../images/gallerium/onDemand/oral-thumbnail.png'
import posterThumbnail from '../../images/gallerium/onDemand/poster2-thumbnail.png'

import {
  // awardsVideos,
  // lunchBreakfastSymposiumVideos,
  // masterclassVideos,
  onDemandVideosType,
  // planeriesVideos,
  virtualSatelliteSymposiumsVideos,
  subspecialtyVideos,
  virtualProductTheatreVideos,
} from './videos'
import routes from 'src/routes'

export interface onDemandCategoryType {
  id: string
  categoryName: string
  thumbnail: string
  destination: string
  videos?: Array<onDemandVideosType>
}

const onDemandCategories: Array<onDemandCategoryType> = [
  // {

  //   id: 'cat1',
  //   categoryName: 'Plenaries',
  //   thumbnail: videoImage,
  //   destination: '/on-demand/plenaries',
  //   videos: planeriesVideos,
  // },
  // {
  //   id: 'cat3',
  //   categoryName: 'Awards',
  //   thumbnail: posterImage,
  //   destination: '/on-demand/awards',
  //   videos: awardsVideos,
  // },
  {
    id: 'cat4',
    categoryName: 'Oral Presentations',
    thumbnail: oralThumbnail,
    destination: routes.onDemandOral,
  },
  {
    id: 'cat5',
    categoryName: 'E Poster Presentations',
    thumbnail: posterThumbnail,
    destination: routes.onDemandPoster,
  },
  {
    id: 'cat3',
    categoryName: 'Best Basic Science Poster Awards',
    thumbnail: posterImage,
    destination: routes.onDemandBbs,
  },
  {
    id: 'cat2',
    categoryName: 'Sub-specialty',
    thumbnail: videoImage,
    destination: '/on-demand/sub-specialty',
    videos: subspecialtyVideos,
  },
  // {
  //   id: 'cat6',
  //   categoryName: 'Masterclass',
  //   thumbnail: videoImage,
  //   destination: '/on-demand/masterclass',
  //   videos: masterclassVideos,
  // },
  // {
  //   id: 'cat7',
  //   categoryName: 'Lunch & Breakfast Symposiums',
  //   thumbnail: videoImage,
  //   destination: '/on-demand/lunch-and-breakfast-symposiums',
  //   videos: lunchBreakfastSymposiumVideos,
  // },
  {
    id: 'cat8',
    categoryName: 'Virtual Satellite Symposiums',
    thumbnail: videoImage,
    destination: '/on-demand/sponsored-symposiums',
    videos: virtualSatelliteSymposiumsVideos,
  },
  {
    id: 'cat9',
    categoryName: 'Virtual Product Theatre',
    thumbnail: videoImage,
    destination: '/on-demand/virtual-product-theatre',
    videos: virtualProductTheatreVideos,
  },
]

export { onDemandCategories }
